import $ from 'jquery';

const $filter = $('form.filter');

$filter.on('change', e => {
    if (window.innerWidth > 1000) $filter.submit();
});

$('.remove-filter').on('click', e => {
    const $this = $(e.currentTarget).parent();
    const $input = $filter.find(`[name="${$this.data('name')}"][value="${$this.data('value')}"]`);
    if ($input.is(':checked')) $input.prop('checked', false);
    if ($input.is(':hidden')) $input.remove();

    $this.slideUp();
    if ($this.data('name') === 'size1') {
        const $size2 = $this.parent().find('[data-name=size2] .remove-filter');
        if ($size2.length) return $size2.click();
    }
    if ($this.data('name') === 'size2') {
        const $size3 = $this.parent().find('[data-name=size3] .remove-filter');
        if ($size3.length) return $size3.click();
    }

    if (window.innerWidth > 1000) $filter.submit();
});

$(document).on('click', (e) => {
    if ($(e.target).hasClass('tooltip-icon')) {
        const $tooltipIcon = $(e.target);
        const $container = $tooltipIcon.parent().parent();
        const $tooltip = $container.find('.tooltip');
        const tooltipPosition = $tooltipIcon.position().left + $tooltipIcon.outerWidth();
        $tooltip.css({
            position: 'absolute',
            left: tooltipPosition + 10,
        });
        $tooltip.fadeToggle();
    } else {
        $('.tooltip').fadeOut();
    }
});

$('.filter_group').on('click', '.filter_title', e => {
    const $group = $(e.delegateTarget);
    if (!$(e.target).hasClass('tooltip-icon')) {
        $group.find('.filter_options').slideToggle();
    }
    if ($(e.target).hasClass('filter_title')) {
        console.log($group.parent());
        $group.toggleClass('arrow-rotate');
    } else if ($(e.target).is(':header')) {
        $group.toggleClass('arrow-rotate');
    }
});

$(document).ready(function() {
    $("#filter-button, .apply-filters, #close").click(function() {
        $("#filter").toggleClass("show-sidebar");
    });
});